import { Button, ButtonType } from '@soteria/design-system-ve';

import * as styles from './AudioRecordingCard.css.ts';

interface AudioRecordingCardProps {
  isActive?: boolean;
  isRecording: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
}

/**
 * AudioRecordingCard - Simplified audio recording component for tabbed interface
 */
export function AudioRecordingCard({ isActive: _isActive = false, isRecording, onStartRecording, onStopRecording }: AudioRecordingCardProps) {
  const handleToggleRecording = () => {
    if (isRecording) {
      onStopRecording();
    } else {
      onStartRecording();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.recordingArea}>
        <div className={styles.microphoneIcon}>
          <svg fill="none" height="64" viewBox="0 0 24 24" width="64" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V11C9 12.66 10.34 14 12 14ZM11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V11C13 11.55 12.55 12 12 12C11.45 12 11 11.55 11 11V5ZM17 11C17 14 14.76 16.1 12 16.1C9.24 16.1 7 14 7 11H5C5 14.41 7.72 17.23 11 17.72V21H13V17.72C16.28 17.24 19 14.42 19 11H17Z"
              fill="currentColor"
            />
          </svg>
        </div>

        <div className={styles.recordingText}>
          <div className={styles.primaryText}>{isRecording ? 'Recording in progress...' : 'Click to start recording'}</div>
          <div className={styles.secondaryText}>{isRecording ? 'Click stop when finished' : 'Record audio content for classification'}</div>
        </div>

        <Button buttonType={isRecording ? ButtonType.Danger : ButtonType.Primary} onClick={handleToggleRecording}>
          {isRecording ? 'STOP' : 'RECORD'}
        </Button>
      </div>
    </div>
  );
}
